import { useEffect } from "react";
import { Navbar } from "@/components/okaia/Navbar";
import { Footer } from "@/components/okaia/Footer";
import { Reveal } from "@/components/okaia/Reveal";

const CONTENT = {
  mentions: {
    title: "Mentions légales",
    description:
      "Mentions légales du site OKAÏA Dév : éditeur, forme juridique, SIREN/SIRET, hébergement et propriété intellectuelle.",
    blocks: [
      {
        h: "Éditeur du site",
        p: "OKAÏA Dév (nom commercial) — Entrepreneur individuel (EI). Entrepreneur : Léandre GUYE. SIREN : 350 272 795 — SIRET : 350 272 795 00047. Date de début d'activité : 01/09/2026. Siège / domiciliation professionnelle : 8 rue Lemercier, 75017 Paris, France.",
      },
      {
        h: "Directeur de la publication",
        p: "Léandre GUYE.",
      },
      {
        h: "Hébergement",
        p: "OVH SAS — 2 rue Kellermann, 59100 Roubaix, France.",
      },
      {
        h: "Propriété intellectuelle",
        p: "L'ensemble des contenus présents sur ce site (textes, identité visuelle, structure) est la propriété d'OKAÏA Dév, sauf mention contraire. Toute reproduction sans autorisation préalable est interdite.",
      },
      {
        h: "Contact",
        p: "contact@okaiadev.fr",
      },
    ],
  },
  confidentialite: {
    title: "Politique de confidentialité",
    description:
      "Politique de confidentialité du site OKAÏA Dév : données collectées, finalités, droits RGPD, stockage local et services externes.",
    blocks: [
      {
        h: "Responsable de traitement",
        p: "OKAÏA Dév — Entrepreneur individuel (EI), représenté par Léandre GUYE. SIRET : 350 272 795 00047.",
      },
      {
        h: "Hébergement",
        p: "Le site est hébergé chez OVH SAS — 2 rue Kellermann, 59100 Roubaix, France.",
      },
      {
        h: "Données collectées et services externes",
        p: "Ce site ne collecte pas directement de données personnelles. Deux services externes sont utilisés : TidyCal pour la réservation du Diagnostic Business (avec ses questions préparatoires), et Tally pour le questionnaire gratuit d'orientation formation. Les informations que vous transmettez sur ces plateformes sont traitées afin d'organiser le rendez-vous, comprendre votre situation ou étudier votre demande d'orientation. Chaque service externe applique également sa propre politique de confidentialité.",
      },
      {
        h: "Finalité",
        p: "Les informations transmises servent exclusivement à organiser votre rendez-vous, comprendre votre situation et vos besoins, préparer le Diagnostic Business ou étudier votre demande d'orientation formation afin de vous orienter vers des solutions adaptées.",
      },
      {
        h: "Vos droits",
        p: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, écrivez à contact@okaiadev.fr.",
      },
      {
        h: "Cookies et stockage local",
        p: "Ce site n'utilise aucun cookie publicitaire ni traceur. Il utilise uniquement le stockage local de votre navigateur, nécessaire pour mémoriser le choix effectué sur le bandeau de confidentialité.",
      },
    ],
  },
};

export default function LegalPage({ type }) {
  const { title, description, blocks } = CONTENT[type];
  useEffect(() => {
    document.title = `${title} — OKAÏA Dév`;
    const meta = document.querySelector('meta[name="description"]');
    const original = meta?.getAttribute("content");
    meta?.setAttribute("content", description);
    const canonical = document.querySelector('link[rel="canonical"]');
    const originalCanonical = canonical?.getAttribute("href");
    const path = type === "mentions" ? "mentions-legales" : "confidentialite";
    canonical?.setAttribute("href", `${window.location.origin}/${path}`);
    return () => {
      document.title = "OKAÏA Dév — Diagnostic Business : clarté et direction en 30 minutes";
      if (original) meta?.setAttribute("content", original);
      if (originalCanonical) canonical?.setAttribute("href", originalCanonical);
    };
  }, [title, description, type]);
  return (
    <main data-testid={`legal-page-${type}`}>
      <Navbar />
      <section className="bg-[#0B2215] px-6 pb-16 pt-40 md:px-12">
        <div className="mx-auto max-w-[1400px]">
          <p className="okaia-overline mb-6 text-[#C8A97E]">OKAÏA Dév</p>
          <h1 className="font-serif-display text-4xl tracking-tight text-[#F9F8F6] md:text-5xl">{title}</h1>
        </div>
      </section>
      <section className="bg-[#F9F8F6] py-20 md:py-28">
        <div className="mx-auto max-w-3xl px-6 md:px-12">
          {blocks.map((b, i) => (
            <Reveal key={i}>
              <div className="mb-10">
                <h2 className="mb-3 font-serif-display text-2xl tracking-tight text-[#0B2215]">{b.h}</h2>
                <p className="text-base font-light leading-relaxed text-[#4A5A52]">{b.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <Footer />
    </main>
  );
}
